import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { LOCALE_CODES } from '@VineyardLibConstant/constant';

export class VineyardDateFnsAdapter extends DateFnsAdapter {
  /**
   * カレンダーの対象月の日付の配列を言語対応を行い返却する
   * ※mat-datepickerのカレンダーから呼び出し
   */
  override getDateNames(): string[] {
    if (this.locale.code != LOCALE_CODES.JA) {
      return super.getDateNames(); // 日本語以外は単位がないので通常の処理を呼び出す
    }
    // 日本語の場合カレンダーに「1日」のように表示されてしまうので「日」を消す
    return super.getDateNames().map((v) => v.replace('日', ''));
  }

  /**
   * カレンダーの曜日のフォーマットを返す
   */
  override getDayOfWeekNames(): string[] {
    // デフォルトだと、narrowフォーマットでの返却となり1文字で返される。
    // shortフォーマットで曜日を返却する
    // 例 ja:月 en:Mon fr:lun.
    return super.getDayOfWeekNames('short');
  }
}
